import React from 'react'
import classes from '../Navbar.module.scss'

const NavbarTabCounter: React.FC<{
  children: number
  className?: string
}> = ({
  children,
  className,
}) => {
  return children ? (
    <span className={`${classes.navbarTabCounter} ${className}`}>
      {children > 999 ? 999 : children}
    </span>
  ) : null
}

export default NavbarTabCounter
